export default __webpack_public_path__ + "static/media/sell.990d53c0.png";